var spLength = $('.slide_point p').length,
  scimgWidth = $(window).width(),
  sulWidth = scimgWidth * spLength,
  sNum = 0;
  $(".slide_cont ul").width(sulWidth);
  $(".slide_cont ul li").width(scimgWidth);
  
// 鼠标移入的滑块进行滚动
$('.slide_point p').click(function(){
    //clearInterval(sTimer);
    sNum = $(this).index();
    showPics(sNum);
});

// 图片自动滚动
function showPics(sNum){
    $(".slide_point p").eq(sNum).addClass("cur_point").siblings().removeClass("cur_point");
    $(".slide_cont ul").animate({
        "margin-left" : -scimgWidth * sNum 
    });

}
window.addEventListener('resize', function() {
  spLength = $('.slide_point p').length;
  scimgWidth = $(window).width();
  sulWidth = scimgWidth * spLength;
  sNum = 0;
  $(".slide_cont ul").width(sulWidth);
  $(".slide_cont ul li").width(scimgWidth);
})

var swiper = new Swiper('.swiper-container1', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        autoplay:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });